import { Component } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { CrudPage } from '@zendra/shared';
import { GetGisStandInconsistenciesInputDto, GisStandInconsistencyCase } from 'orchestrator';
import { GisStandInconsistencyBase } from '../gis-stand-inconsistency/gis-stand-inconsistency-base';
import {
  GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG,
  GISSTANDINCONSISTENCYONLYINZENDRA_FIELDS,
} from './gis-stand-inconsistency-only-in-zendra.config';

@Component({
  selector: 'app-gis-stand-inconsistency-only-in-zendra',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class GisStandInconsistencyOnlyInZendra extends GisStandInconsistencyBase {
  config = GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG;
  fields = GISSTANDINCONSISTENCYONLYINZENDRA_FIELDS;

  protected override get caseFilter(): Partial<GetGisStandInconsistenciesInputDto> {
    return { case: GisStandInconsistencyCase.OnlyInZendra };
  }

  protected getEntityName(): string {
    return 'GisStandInconsistencyOnlyInZendra';
  }
}